/**
 * Мини-хелпер объединения классов (замена clsx — его нет в зависимостях).
 * Принимает строки, undefined/false/null (условные классы) и объединяет через пробел.
 */
export type ClassValue = string | number | false | null | undefined;

export function cx(...values: ClassValue[]): string {
  let out = '';
  for (const v of values) {
    if (!v && v !== 0) continue;
    out = out ? `${out} ${String(v)}` : String(v);
  }
  return out;
}
